import React from 'react';
import styles from '../CheckTile.module.css';
import classes from '@components/Fireboard/components/Body/TileView/ChecksCard/checksCard.module.scss';
import cn from 'classnames';

const TileHeader = ({ check, currentMode }) => {
  const isChannel =
    currentMode !== 'ON_PREMISE' && currentMode !== 'TABLE_DELIVERY';
  const isStatus = currentMode !== 'ON_PREMISE';
  return (
    <div
      className={cn(
        classes.TileHeaderContainer,
        'col-12 p-0  d-flex mx-0 align-items-center'
      )}
    >
      <div
        className={cn(
          classes.TileHeader,
          styles.headerColor,
          'w-100 d-flex align-items-center',
          currentMode === 'ON_PREMISE'
            ? 'justify-content-center'
            : 'justify-content-between'
        )}
      >
        {isChannel && <div className={classes.channelIcon}>{check?.mode}</div>}
        <div
          className={cn(
            'd-flex px-1 text-truncate',
            currentMode === 'ON_PREMISE' ? 'col-12' : 'col-6',
            currentMode === 'TABLE_DELIVERY'
              ? 'text-left'
              : 'text-center justify-content-center'
          )}
        >
          {currentMode === 'TABLE_DELIVERY' ? (
            <>
              <span>#</span>
              <div className={cn(classes.checkTruncate, 'px-0 text-center')}>
                {check.number}
              </div>
            </>
          ) : (
            <div className={cn('text-truncate col px-0')}>
              {check?.tabName || check?.orderDetails?.orderName || '---'}
            </div>
          )}
        </div>
        {isStatus && (
          <div
            className={cn('rounded-pill fw-400 text-right', classes.statusPill)}
            style={{
              backgroundColor: check?.status?.color,
              border: check?.status?.border,
            }}
          >
            {check.status?.status}
          </div>
        )}
      </div>
    </div>
  );
};

export default TileHeader;
